import env from '../../config/environment'

class Api {
  constructor(http) {
    this.http = http
  }

  get(url, params) {
    return this.request('GET', url, {params: params})
  }

  post(url, data) {
    return this.request('POST', url, {data: data})
  }

  put(url, data) {
    return this.request('PUT', url, {data: data})
  }

  delete(url) {
    return this.request('DELETE', url)
  }

  request(method, url, opts = {}) {
    url = `${env.api_url}${url}`
    opts = angular.extend({headers: cbk.getHeaders(opts.headers), method: method, url: url}, opts)

    return this.http.request(opts)
  }
}

angular.module('eficienciaFiscalModule').service('api', ['httpService', Api])
